var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi mdi-home"})])])],1),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }